var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.aboutUsDetail)?_c('div',{staticClass:"px-30"},[_c('p',{staticClass:"py-6"},[_vm._v(_vm._s(_vm.aboutUsDetail.title))]),_c('p',{staticClass:"text-left"},[_vm._v(" "+_vm._s(_vm.delHtmlTag(_vm.aboutUsDetail.content))+" ")])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }